import { createClientApi } from '@local/finsera-core/src/api';
import { ApiType } from '@local/finsera-core/src/api/api';

// Create an object wrapper that will be mutated after initialization
const apiWrapper: { instance: ApiType | null } & Partial<ApiType> = {
  instance: null,
};

export const initApi = (store: any, actions: any) => {
  const apiInstance = createClientApi(store, actions);

  // Assign the API instance
  apiWrapper.instance = apiInstance;

  // Copy all API methods to the wrapper object so they can be called directly
  Object.assign(apiWrapper, apiInstance);
};

export default apiWrapper as unknown as ApiType;
